import CommonService from "./common.service";
import superAdminApi from "./superAdminApi";

const ME = "/me";
const SUPPORT = "/support";
const MANAGER = "/support-manager";
const SUPER = "/super-admin";

export const ticketExtractMessage = (err, fallback = "Request failed") =>
  err?.response?.data?.message || err?.response?.data?.error || err?.message || fallback;

export const createMySupportTicket = async (formData) => {
  const res = await CommonService.post(`${ME}/tickets`, formData, { silent: true });
  return res?.data ?? null;
};

export const fetchMySupportTickets = async (params = {}) => {
  const res = await CommonService.get(`${ME}/tickets`, params, { silent: true });
  return res?.data ?? { items: [], total: 0 };
};

export const fetchMySupportTicketStats = async () => {
  const res = await CommonService.get(`${ME}/tickets/stats`, {}, { silent: true });
  return (
    res?.data ?? {
      total: 0,
      inProgress: 0,
      resolved: 0,
      closed: 0,
    }
  );
};

export const fetchMySupportTicketById = async (id) => {
  const res = await CommonService.get(`${ME}/tickets/${id}`, {}, { silent: true });
  return res?.data ?? null;
};

export const postMySupportTicketMessage = async (id, { message, attachment }) => {
  const form = new FormData();
  form.append("message", message || "");
  if (attachment) form.append("attachment", attachment);
  const res = await CommonService.post(`${ME}/tickets/${id}/messages`, form, { silent: true });
  return res?.data ?? null;
};

export const fetchSupportAssignedTickets = async (params = {}) => {
  const res = await CommonService.get(`${SUPPORT}/tickets`, params, { silent: true });
  return res?.data ?? { items: [], total: 0 };
};

export const fetchSupportAssignedTicketStats = async () => {
  const res = await CommonService.get(`${SUPPORT}/tickets/stats`, {}, { silent: true });
  return (
    res?.data ?? {
      total: 0,
      inProgress: 0,
      resolved: 0,
      closed: 0,
    }
  );
};

export const fetchSupportTicketById = async (id) => {
  const res = await CommonService.get(`${SUPPORT}/tickets/${id}`, {}, { silent: true });
  return res?.data ?? null;
};

export const updateSupportTicketStatus = async (id, payload) => {
  const res = await CommonService.patch(`${SUPPORT}/tickets/${id}/status`, payload, { silent: true });
  return res?.data ?? null;
};

export const postSupportTicketMessage = async (id, { message, isInternal, attachment }) => {
  const form = new FormData();
  form.append("message", message || "");
  form.append("isInternal", isInternal ? "true" : "false");
  if (attachment) form.append("attachment", attachment);
  const res = await CommonService.post(`${SUPPORT}/tickets/${id}/messages`, form, { silent: true });
  return res?.data ?? null;
};

export const fetchManagerTickets = async (params = {}) => {
  const res = await CommonService.get(`${MANAGER}/tickets`, params, { silent: true });
  return res?.data ?? { items: [], total: 0 };
};

export const fetchManagerTicketById = async (id) => {
  const res = await CommonService.get(`${MANAGER}/tickets/${id}`, {}, { silent: true });
  return res?.data ?? null;
};

export const fetchManagerTicketAssignees = async () => {
  const res = await CommonService.get(`${MANAGER}/tickets/assignees`, {}, { silent: true });
  return res?.data?.items ?? [];
};

export const assignManagerTicket = async (id, payload) => {
  const res = await CommonService.post(`${MANAGER}/tickets/${id}/assign`, payload, { silent: true });
  return res?.data?.ticket ?? null;
};

export const updateManagerTicketPriority = async (id, payload) => {
  const res = await CommonService.patch(`${MANAGER}/tickets/${id}/priority`, payload, { silent: true });
  return res?.data ?? null;
};

export const fetchSuperAdminTickets = async (params = {}) => {
  const res = await superAdminApi.get(`${SUPER}/tickets`, { params });
  return res.data?.data ?? { items: [], total: 0, page: 1, pageSize: 20 };
};

export const fetchSuperAdminTicketById = async (id) => {
  const res = await superAdminApi.get(`${SUPER}/tickets/${id}`);
  return res.data?.data ?? null;
};

export const TICKET_STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "new", label: "New" },
  { value: "assigned", label: "Assigned" },
  { value: "in_progress", label: "In Progress" },
  { value: "waiting_customer", label: "Waiting for Customer" },
  { value: "under_investigation", label: "Under Investigation" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
  { value: "reopened", label: "Reopened" },
];

export const TICKET_PRIORITY_OPTIONS = [
  { value: "", label: "All Priorities" },
  { value: "Low", label: "Low" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
  { value: "Urgent", label: "Urgent" },
];

export const TICKET_CATEGORY_OPTIONS = [
  { value: "", label: "All Categories" },
  { value: "account_profile", label: "Account & Profile" },
  { value: "technical", label: "Technical Issue" },
  { value: "payment_billing", label: "Payment & Billing" },
  { value: "product_listing", label: "Product & Listing" },
  { value: "orders_transactions", label: "Orders & Transactions" },
  { value: "feature_request", label: "Feature Request" },
  { value: "other", label: "Other" },
];
